import { LearningDynamicsLesson } from './types'

/**
 * % успеха темы — среднее арифметическое по всем работам внутри неё.
 * Незапущенные работы (progress = null) считаем нулём, чтобы средний
 * процент не завышался за счёт того, что ученик их ещё не открывал.
 */
export const getThemeProgress = (
  lessons?: LearningDynamicsLesson[] | null,
): number => {
  if (!lessons?.length) return 0

  const total = lessons.reduce((sum, lesson) => sum + (lesson.progress ?? 0), 0)

  return Math.round(total / lessons.length)
}
